var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9815_26123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 3C16.96 3 21 7.04 21 12C21 13.42 20.66 14.76 20.07 15.96C18.54 14.24 16.09 13.07 12.69 12.93C14.57 12.6 16 10.97 16 9C16 6.79 14.21 5 12 5C9.79 5 8 6.79 8 9C8 10.97 9.43 12.6 11.31 12.93C7.91 13.07 5.46 14.24 3.93 15.96C3.34 14.76 3 13.42 3 12C3 7.04 7.04 3 12 3ZM9 9C9 7.35 10.35 6 12 6C13.65 6 15 7.35 15 9C15 10.65 13.65 12 12 12C10.35 12 9 10.65 9 9ZM12 21C8.84 21 6.06 19.36 4.45 16.88C6.01 14.93 8.61 13.9 12 13.9C15.39 13.9 17.99 14.93 19.55 16.88C17.94 19.36 15.16 21 12 21Z",
    fill: "#3AC309"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9815_26123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.1a3e255dfc543d1ee4ee528f0a92c719.svg";
export { ForwardRef as ReactComponent };